import { createPortal } from "react-dom";
import { useState, useEffect } from "react";
import styles from "./BottomSheet.module.less";
import { Picker } from "react-vant";

const BottomSheet = ({
  visible = false,
  onClose = () => {},
  onConfirm = () => {},
  defaultValue = "", // 当前选中的值
  options = [], // 选项数组
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [shouldRender, setShouldRender] = useState(visible);
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
      // 延迟触发动画，确保DOM已渲染
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      // 等待动画完成后再卸载组件
      setTimeout(() => setShouldRender(false), 300);
    }
  }, [visible]);

  if (!shouldRender) return null;

  return createPortal(
    <div
      className={`${styles["sheet-overlay"]} ${
        isAnimating ? styles["sheet-overlay--visible"] : ""
      }`}
      onClick={() => onClose()}
    >
      <div
        className={`${styles["sheet-container"]} ${
          isAnimating ? styles["sheet-container--visible"] : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles["content-list"]}>
          <Picker
            placeholder={""}
            title="基础使用"
            showToolbar={false}
            defaultValue={defaultValue}
            columns={options}
            onChange={(val, selectRow, index) => {
              if (index === -1) {
                setSelectedValue(null);
              } else {
                setSelectedValue(selectRow.value);
              }
            }}
          />
        </div>

        <div className={styles["button-box"]}>
          <img
            src={require("@/images/picture/intro-test/cancel-phone.png")}
            className={styles["button-box-item"]}
            onClick={() => onClose()}
          />
          <img
            src={require("@/images/picture/intro-test/confirm-phone.png")}
            className={styles["button-box-item"]}
            onClick={() => onConfirm(selectedValue)}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default BottomSheet;
